import { Button, Group, Modal, Radio, TextInput } from '@mantine/core';
import { useEffect, useState } from 'react';

import { API_ENDPOINT } from '@/config/endpoint';
import { ButtonTypes } from './Buttons/Button';
import DMText from './DMText';
import Toast from './Toast';
import { createStyles } from '@mantine/core';
import { messages } from '@/consts/Messages';
import { mixpanelTrack } from '@/utils/mixpanel';
import themeVariables from '@/styles/themeVariables';

const useReportModalStyle = createStyles(() => ({
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
  },

  radioGroupContainer: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 12,
  },

  submitButton: {
    marginTop: 24,
  },
}));

const ReportModal = ({ visible, setVisible, type, typeId }) => {
  const { classes } = useReportModalStyle();

  const [reasonTypes, setReasonTypes] = useState([]);
  const [selectedReasonType, setSelectedReasonType] = useState(null);
  const [reportText, setReportText] = useState('');

  useEffect(() => {
    if (visible) {
      mixpanelTrack('ReportModal', 'Viewed');
      API_ENDPOINT.report
        .getReportReasonTypes()
        .then((res) => setReasonTypes(res.data.items));
    }
  }, [visible]);

  return (
    <Modal
      centered
      size={360}
      opened={visible}
      withinPortal
      closeOnClickOutside={true}
      withCloseButton={false}
      onClose={() => {
        setVisible(false);
      }}
      padding={24}
      zIndex={2100}
    >
      <div className={classes.modalContainer}>
        <DMText
          size={21}
          weight={700}
          m={8}
          dColor={themeVariables.darkMode.strong}
          data-autofocus
        >
          신고하기
        </DMText>
        <Radio.Group onChange={(value) => setSelectedReasonType(value)}>
          <Group className={classes.radioGroupContainer}>
            {reasonTypes.map((item) => (
              <Radio key={item.text} value={item.type} label={item.text} />
            ))}
          </Group>
        </Radio.Group>
        {selectedReasonType === 'ETC' && (
          <TextInput
            mt={12}
            variant={'filled'}
            placeholder={'자세한 내용을 적어주세요'}
            onChange={(e) => {
              setReportText(e.target.value);
            }}
          />
        )}
        <Button
          fullWidth={true}
          className={classes.submitButton}
          type={ButtonTypes.solidColored}
          onClick={() => {
            if (!selectedReasonType) {
              toast.error(messages.REPORT_REASON_NOT_DESCRIBED);
              return;
            }
            API_ENDPOINT.report
              .submitReport(type, typeId, selectedReasonType, reportText)
              .then(() => {
                setVisible(false);
                Toast.success(messages.REPORT_SUBMITTED_SUCCESSFULLY);
              });
          }}
        >
          신고 제출하기
        </Button>
      </div>
    </Modal>
  );
};

export default ReportModal;
